import { render, staticRenderFns } from "./SearchTeaser.vue?vue&type=template&id=40058e2d"
import script from "./SearchTeaser.js?vue&type=script&lang=js&external"
export * from "./SearchTeaser.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports